module.exports = __webpack_public_path__ + "img/bt_logo.e183fcbf.png";